var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForecastScheduleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8296 10.8049C17.8296 14.684 14.685 17.8286 10.8059 17.8286C6.92684 17.8286 3.78223 14.684 3.78223 10.8049H10.8059V3.78125C14.685 3.78125 17.8296 6.92586 17.8296 10.8049Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6113 10.8057C21.6113 16.7735 16.7735 21.6113 10.8057 21.6113C4.83786 21.6113 0 16.7735 0 10.8057C0 4.83786 4.83786 0 10.8057 0C16.7735 0 21.6113 4.83786 21.6113 10.8057ZM19.4502 10.8057C19.4502 15.5799 15.5799 19.4502 10.8057 19.4502C6.0314 19.4502 2.16113 15.5799 2.16113 10.8057C2.16113 6.0314 6.0314 2.16113 10.8057 2.16113C15.5799 2.16113 19.4502 6.0314 19.4502 10.8057Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForecastScheduleIcon);
export default __webpack_public_path__ + "static/media/forecastScheduleIcon.d41a1747b03f9f37db2cdd4680cb6310.svg";
export { ForwardRef as ReactComponent };